import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

// Helper function to bold section headings
function formatTerms(text) {
  const headings = [
    'Changing or Cancelling orders',
    'Returns Policy',
    'Returns for defective items',
    'Returns for change of mind',
    'Reviewing Orders',
    'Delivery Expectations',
    'Shipping Expectations',
    'Insufficient and/or Incorrect Delivery Information',
    'Cheque and Bank Transfers',
    'Charging of Credit Cards',
    'Orders with Multiple Items',
    'Privacy',
    'Disclaimer'
  ];
  let formatted = text;
  headings.forEach(h => {
    const regex = new RegExp(`(^|\\n)(${h})`, 'g');
    formatted = formatted.replace(
      regex,
      `$1<span class="terms-heading">$2</span>`
    );
  });
  return formatted;
}

const termsText = `
All prices are shown in Indian Rupees (INR).

By purchasing from Indian Book House, you confirm that the goods are for your personal or business use and not for resale, unless otherwise agreed in writing.

Indian Book House communicates primarily via the email address linked to your account. Please ensure your email is correct and check all your email accounts if you have more than one. We are not responsible for missed communications due to incorrect email addresses.

Changing or Cancelling orders
If you need to change or cancel your order, please contact Indian Book House Customer Care as soon as possible. Changes or cancellations can only be made before your order begins processing at our Distribution Centre or with our suppliers. Once processing has started, changes are not possible and we cannot combine multiple orders. Adding or substituting items may affect shipping times. Refunds for cancellations are only possible if we confirm the change was processed in time; otherwise, a store credit may be offered.

Returns Policy
This policy does not limit your rights under Indian Consumer Law.

Returns for defective items
If you receive an incorrect, damaged, or faulty item, contact our Customer Care team promptly. Under Indian Consumer Law, you are entitled to a replacement or refund for major failures and compensation for other foreseeable loss or damage. We may require evidence of the issue and may ask you to return the item for assessment. If a return is needed, we will provide instructions and cover return shipping costs.

Returns for change of mind
Contact Customer Care before returning any item. Returns for change of mind are at our discretion. If accepted, you must pay return postage and will receive a store credit (excluding shipping costs) for approved items. Items must be returned in new, resaleable condition and securely packed. Returns without approval or not meeting these conditions may not be credited or refunded.

The following items cannot be returned for change of mind:
- Magazine Subscriptions
- Gift Certificates
- eBooks or other digital content
- Bulk Orders with special pricing or sourcing
- Print on Demand titles

Reviewing Orders
We review every order before processing and only authorise items we can source. If an item is unavailable, we may suggest alternatives and you will not be charged for items we cannot supply. Orders can be cancelled if unshipped within 120 days, unless already in transit from a supplier.

Delivery Expectations
For items in stock at our warehouse, the product page will show 'in stock' and an estimated shipping time. Occasionally, stock may run out before the website updates. For items not in stock, we will order from suppliers, which may affect delivery times. We will notify you of any delays.

After placing your order, we will source your items and keep you updated via email or our logistics partners. Delivery times may vary by location. If delivery is unsuccessful after three attempts, the shipment will be returned and you may be responsible for return charges. For Cash on Delivery (COD) orders, we may call to verify your order. Delays in verification may delay shipping.

Shipping Expectations
We aim to ship items within the timeframe listed on the product page. Special or rare titles may take longer to source. Some titles may take several weeks or months to arrive. We will keep you informed of shipping times and any delays.

Once your order ships, you will receive an email confirmation.

Insufficient and/or Incorrect Delivery Information
Address changes in your account only affect future orders. For current orders, contact Customer Care immediately. Incorrect or insufficient address details may result in delayed delivery, lost parcels, or returned packages. If we make an addressing error, we will cover resending or refunding the item. If the error is on your part, your order may be cancelled and a store credit issued.

If a package is lost by our shipping partner, we will replace the items or issue a store credit if a replacement is not possible.

Cheque and Bank Transfers
If payment by cheque or money order is not received within 14 days, or bank transfer within 30 days, your order will be cancelled. If stock or prices change before payment is received, your order may be cancelled. Always include your order number as a reference and notify us when payment is made.

Charging of Credit Cards
All purchases are charged at checkout. If an item becomes unavailable after purchase, you will be refunded for that item. If delays occur, we will notify you of your options. Orders may be cancelled if payment is not received in time.

Orders with Multiple Items
Orders with multiple items may be shipped in separate packages. We may consolidate shipments where possible. If you need items shipped separately, additional postage may apply.

Privacy
Your personal information is kept confidential and secure, in accordance with our privacy policy. We only share your information with suppliers or delivery partners as needed to complete your order. We do not rent or sell your information to third parties.

Third-Party Service Providers: We may provide your email or mobile number to delivery partners for tracking updates.

Disclaimer
Information on the Indian Book House website may contain errors or inaccuracies. Indian Book House is not liable for any such errors to the fullest extent permitted by law.
`;

const Terms = () => (
  <Container maxWidth="xl" sx={{ py: 4 }}>
    <Typography variant="h4" fontWeight={600} sx={{ mb: 2, fontFamily: 'Poppins' }}>
      Terms & Conditions
    </Typography>
    <Divider sx={{ mb: 1 }} />
    <Box
      sx={{
        fontFamily: 'Poppins',
        fontSize: 15,
        color: '#222',
        lineHeight: 1.7,
        whiteSpace: 'pre-line'
      }}
      dangerouslySetInnerHTML={{
        __html: formatTerms(termsText)
      }}
    />
    <style>
      {`
        .terms-heading {
          display: block;
          font-weight: bold;
          font-size: 1.08em;
          margin-top: 1em;
          margin-bottom: 0.2em;
        }
      `}
    </style>
  </Container>
);

export default Terms;